@if (type === 'CdSettings') {
  <h2 mat-dialog-title>{{'resetCdSettings' | translate}}</h2>
}
@if (type === 'Users') {
  <h2 mat-dialog-title>{{'delete' | translate}} "{{user}}"</h2>
}
@if (type !== 'CdSettings' && type !== 'Users' && type !== 'Token' && type !== 'Interface' && type !== 'FormResult') {
  <h2 mat-dialog-title>{{'delete' | translate}} {{type}}</h2>
}
@if (type == 'Token' || type == 'Interface' || type == 'FormResult') {
  <h2 mat-dialog-title>{{'delete' | translate}}</h2>
}

<mat-dialog-content>
  <div class="pt-2">
    <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >
      @if (type == 'CdSettings') {
        <div class="p-3 delete-infos">
          <p><strong style="color:var(--warmOrange);" >{{'delete_ask_cd' | translate}}</strong></p>
        </div>
      }
      @if (type == 'Users') {
        <div class="p-3 delete-infos">
          <p><strong style="color:var(--warmOrange);" >{{'deleteUser' | translate}}</strong></p>
        </div>
      }
      @if (type !== 'CdSettings' && type !== 'Users') {
        <div class="p-3 delete-infos">
          <p>{{'delete_msg' | translate}} {{type}}  </p>
          @if (title) {
            <p><i>{{title}}</i></p>
          }
          <hr>
            <p><strong style="color:#f46565" >{{'delete_ask' | translate}}</strong></p>
          </div>
        }
      </section>
    </div>
  </mat-dialog-content>


  <mat-dialog-actions align="end">
    <button mat-button style="color:var(--warmOrange);" (click)="cancelDelete();">
      {{'cancel' | translate}}
    </button>
    <button mat-button class="orange-button" (click)="onDelete();">
      @if (type == 'CdSettings') {
        <span>{{'reset' | translate}}</span>
      }
      @if (type != 'CdSettings') {
        <span>{{'delete' | translate}}</span>
      }
    </button>
  </mat-dialog-actions>